import { Card, Col, Table } from "react-bootstrap";
import React from "react";

import { useTranslation } from "react-i18next";

const efoodImage = require("assets/img/integrators/efood.png");
const woltImage = require("assets/img/integrators/wolt.png");
const boxImage = require("assets/img/integrators/box.png");
const goImage = require("assets/img/integrators/gonnaorder.png");
const dmImage = require("assets/img/integrators/deliverymanager.png");

function DeliveryGuySalesTable({ deliveryGuyName, data }) {
  const {
    t,
  } = useTranslation();

  const totalSum = data.reduce((acc, row) => acc + parseFloat(row.total), 0);
  const totalTips = data.filter((el) => el.tip != null).reduce((acc, row) => acc + parseFloat(row.tip), 0);

  const getImageByIntegratorId = (integratorId) => {
    switch (integratorId) {
      case 1:
        return efoodImage;
      case 2:
        return woltImage;
      case 3:
        return boxImage;
      case 5:
        return goImage;
      case 6:
        return dmImage;
      default:
        return "";
    }
  };

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Col>
          <Card.Title as="h4">{`${deliveryGuyName}`}</Card.Title>
        </Col>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>{t("tables.headers.plat")}</th>
              <th>{t("tables.headers.customer")}</th>
              <th>{t("tables.headers.addr")}</th>
              <th>{t("tables.headers.pay")}</th>
              <th>{t("tables.headers.totalEuro")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td>{`#${row.friendlyId} (${row.localId})`}</td>
                <td>
                  <div>
                    {row.integratorId ? (
                      <>
                        <img className="integrator-image" alt="..." src={getImageByIntegratorId(row.integratorId)}></img>#{row.integratorOrderId}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </td>
                <td>{row.clientName}</td>
                <td>{row.fullAddress}</td>
                <td>{row.paymentMethod.name}</td>
                {row.tip && row.tip > 0 ? (
                  <td>
                    {`${row.total.toFixed(2)}€ + `}
                    <strong>{row.tip.toFixed(2)} €</strong>
                  </td>
                ) : (
                  <td>{`${row.total.toFixed(2)}€`}</td>
                )}
              </tr>
            ))}
            <tr key="total">
              <td>
                <strong>{data.length}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <strong>
                  {totalSum.toFixed(2)}€ + {totalTips.toFixed(2)}€
                </strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default DeliveryGuySalesTable;
